<template>
  <div class="columns">
    <div class="column is-1"></div>

    <div class="column is-10">
      <nav class="panel">
        <div class="panel-heading title is-size-3">
          <div class="columns">
            <div class="column">
              <p class="title is-5">
                <a href="" @click.prevent="stepBack">
                  <i class="fa fa-chevron-left" aria-hidden="true">
                    Back to overview</i
                  ></a
                >
              </p>
            </div>

            <div
              class="column has-text-right"
              v-if="cordraData.singleObjOwnership"
            >
              <o-button
                variant="primary"
                @click="editDataset('captureevent', objectID)"
                style="margin-right: 1rem"
                >EDIT</o-button
              >
              <o-button variant="danger" @click="deleteChainedDO()"
                >Delete</o-button
              >
            </div>
          </div>

          Capture Event
        </div>
        <div class="panel-block">
          <o-field label="ID:"> {{ objectID }}</o-field>
        </div>
      </nav>
      <o-field label="Camera sensor:">
        <router-link :to="'/cameratraps/' + cordraData.cameratraphandle">{{
          cordraData.cameratraphandle
        }}</router-link></o-field
      >
      <div class="columns">
        <div class="column is-6">
          <o-field label="Beginning capture session:">
            {{ cordraData.time_startDate }}</o-field
          >
        </div>
        <div class="column is-6">
          <o-field label="End capture session:">
            {{ cordraData.time_endDate }}</o-field
          >
        </div>
      </div>

      <hr />

      <o-field label="Created on:"> {{ cordraData.createdOn }}</o-field>

      <section label="Images:" v-if="imagesLoaded">
        <!-- <section label="Images:" v-if="false"> -->
        <Boundingbox :images="cordraData.images" />
      </section>
      <div v-else>There are no images stored.</div>

      <!-- Tabbed View -->
      <hr />
      <o-tabs type="boxed">
        <o-tab-item>
          <template v-slot:header>
            <o-icon icon="info-circle" rootClass="custom-icon"></o-icon>
            <span> Project </span>
          </template>
          <ProjectOverview
            v-if="breadcrumbsStructure.project != null"
            :action="'subcomponentOverview'"
            :objectID="breadcrumbsStructure.project"
          />
        </o-tab-item>
        <o-tab-item>
          <template v-slot:header>
            <o-icon icon="retweet" rootClass="custom-icon"></o-icon>
            <span> Station Layout </span>
          </template>

          <StationsLayout
            v-if="
              breadcrumbsStructure.project != null &&
              breadcrumbsStructure.stationsLayout != null
            "
            :action="'projectView'"
            :projectID="breadcrumbsStructure.project"
            :stationLayoutID="breadcrumbsStructure.stationsLayout"
          />
        </o-tab-item>

        <o-tab-item>
          <template v-slot:header>
            <o-icon icon="retweet" rootClass="custom-icon"></o-icon>
            <span> Station Setup </span>
          </template>
          <StationSetup
            v-if="
              breadcrumbsStructure.stationsLayout != null &&
              breadcrumbsStructure.stationSetup != null
            "
            :action="'stationLayoutView'"
            :stationLayoutID="breadcrumbsStructure.stationsLayout"
            :stationSetupID="breadcrumbsStructure.stationSetup"
          /> </o-tab-item
        ><o-tab-item>
          <template v-slot:header>
            <o-icon icon="info-circle" rootClass="custom-icon"></o-icon>
            <span> Capture Event </span>
          </template>
          Capture Event data, whatever you need
        </o-tab-item>
      </o-tabs>

      <hr />
      <o-field label="Digital Object of this record:">
        <div v-html="generateCordraObjectLink" />
      </o-field>
      <o-field label="RO-Crate Object of this record:">
        <div v-html="generateCordraROCrateObjectLink" />
      </o-field>
    </div>

    <div class="column is-1"></div>
  </div>
  <!-- DEBUG:{{ cordraSearchResult }} -->
</template>

<script setup>
import StationsLayout from "@/components/forms/StationLayoutForm.vue";
import StationSetup from "@/components/forms/StationSetupForm.vue";

import ProjectOverview from "@/components/forms/ProjectForm.vue";
</script>

<script>
import CordraMixin from "@/mixins/cordra";

import CamAndCaptureMixin from "@/mixins/camAndCapture";

import { mapMutations } from "vuex";

import Boundingbox from "@/components/Boundingbox.vue";

export default {
  name: "CameraShow",
  mixins: [CordraMixin, CamAndCaptureMixin],
  components: { Boundingbox },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      objectID: this.$route.params.id,
      breadcrumbsStructure: {
        project: null,
        stationsLayout: null,
        stationSetup: null,
        captureEvent: null,
      },

      cordraData: {
        singleObjOwnership: false,

        images: [],

        dul_hasPart: [],
        ods_capturedAt: "",

        time_startDate: "",
        time_endDate: "",

        createdOn: "",
      },
    };
  },

  methods: {
    ...mapMutations({ newMessage: "messenger/newMessage" }),

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async restoreData() {
      console.group("restoreData()");
      console.log("this.cordraSearchResult", this.cordraSearchResult);

      this.cordraData.singleObjOwnership =
        this.cordraSearchResult[1] || this.$keycloak_isAdmin();

      this.cordraData.time_startDate = new Date(
        this.cordraSearchResult[0].content["startDate"]
      );

      this.cordraData.time_endDate = new Date(
        this.cordraSearchResult[0].content["endDate"]
      );

      this.cordraData.createdOn = new Date(
        this.cordraSearchResult[0].metadata.createdOn
      );

      this.cordraData.images = []; // Reset, then ask vor new images
      let imageObjects = this.cordraSearchResult[0].content["hasPart"];
      if (imageObjects.length === undefined) imageObjects = [];

      for (let imageObject of imageObjects) {
        let url = await this.cordraGetImagePayloadLinkAsync(
          imageObject.id,
          imageObject.content.contentUrl.split("=").pop()
        );

        this.cordraData.images.push({
          URL: url,
          id: imageObject.id,
          annotations: imageObject.content["hasAnnotations"],
        });
      }

      console.groupEnd();
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stepBack() {
      this.$router.push("/showArea/captureevent");
    },

    async deleteChainedDO() {
      //Delete whole digital object with associated objects ImageObject0.1 ans Annotation0.1
      console.group("deleteChainedDO()");
      let imageIDs = [];
      let annotationIDs = [];

      // console.log("this.cordraSearchResult", this.cordraSearchResult);

      this.cordraSearchResult[0].content["media"].forEach((element) => {
        imageIDs.push(element.id);
        annotationIDs = annotationIDs.concat(element.content["hasAnnotations"]);
      });

      let errorFlagImage = imageIDs.length;
      let errorFlagAnnotation = annotationIDs.length;

      for (var annotationID of annotationIDs) {
        let result = await this.cordraDeleteDocument(annotationID, false);
        result ? errorFlagAnnotation-- : null;
      }

      if (errorFlagAnnotation === 0) {
        for (var imageID of imageIDs) {
          let result = await this.cordraDeleteDocument(imageID, false);
          result ? errorFlagImage-- : null;
        }
      } else {
        let message = {
          content: "Error deleting the annotation(-s)",
          kind: "danger",
        };
        this.newMessage(message);
      }

      if (errorFlagImage != 0) {
        let message = {
          content: "Error deleting the image(-s)",
          kind: "danger",
        };
        this.newMessage(message);
      }

      if (errorFlagImage === 0 && errorFlagAnnotation === 0) {
        this.cordraDeleteDocument(this.objectID, true);
      }
      console.log("imageIDs", imageIDs);
      console.log("annotationIDs", annotationIDs);

      console.groupEnd();
    },
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    imagesLoaded() {
      try {
        if (
          this.cordraSearchResult[0].content["hasPart"].length ===
          this.cordraData.images.length
        ) {
          return true;
        }
      } catch {
        return false;
      }
    },
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    this.cordraGetCaptureEventWithMediaAndMetadata(this.objectID);

    this.cordraCreateTemporaryClient()
      .callMethod(this.objectID, "getHierarchyInProject")
      .then((result) => {
        console.log("getHierarchyInProject", result);
        for (let idx of result) {
          console.log(idx);
          if (idx.type == process.env.VUE_APP_CORDRA_DATATYPE_PROJECT) {
            this.breadcrumbsStructure.project = idx.id;
          } else if (
            idx.type == process.env.VUE_APP_CORDRA_DATATYPE_STATIONSLAYOUT
          ) {
            this.breadcrumbsStructure.stationsLayout = idx.id;
          } else if (
            idx.type == process.env.VUE_APP_CORDRA_DATATYPE_STATIONSSETUP
          ) {
            this.breadcrumbsStructure.stationSetup = idx.id;
          }
        }
      })
      .catch((error) => {
        console.log("Error in TheBreadcrumbs", error);
      });
  },
};
</script>
